/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface UniversalTaskHitSchema {
  id: string;
  /** @maxLength 255 */
  title: string;
  /** @maxLength 16 */
  status: string;
  /** @maxLength 40 */
  task_type: string;
  job_id: string;
  /** @maxLength 255 */
  job_title: string;
  project_id: string;
}
